import { Pipe, PipeTransform } from '@angular/core';

/**
 * Generates a string representing the range of items displayed on the current page.
 *
 * This pipe calculates the starting and ending item numbers based on the given
 * page number, the number of items per page, and the total number of available items.
 *
 * Example usage:
 * - `itemsPerPage = 5, currentPageNumber = 1, itemsLength = 22` → Returns `"1-5"`
 * - `itemsPerPage = 5, currentPageNumber = 3, itemsLength = 22` → Returns `"11-15"`
 * - `itemsPerPage = 5, currentPageNumber = 5, itemsLength = 22` → Returns `"21-22"`
 *
 * @param itemsPerPage - The number of items displayed per page.
 * @param currentPageNumber - The current page number (starting from 1).
 * @param itemsLength - The total number of available items.
 *
 * @returns A string in the format `"X-Y"`, where X is the first item on the page, and Y is the last.
 */
@Pipe({
  name: 'paginationInfo',
  standalone: true,
})
export class PaginationInfoPipe implements PipeTransform {
  transform(itemsPerPage: number, currentPageNumber: number, itemsLength: number): string {
    if (!itemsLength) {
      return '0-0';
    }

    const firstElementIndex: number = (currentPageNumber - 1) * itemsPerPage + 1;
    let lastElementIndex: number = currentPageNumber * itemsPerPage;

    if (lastElementIndex > itemsLength) {
      lastElementIndex = itemsLength;
    }

    return `${firstElementIndex}-${lastElementIndex}`;
  }
}
